import { render, staticRenderFns } from "./16.vue?vue&type=template&id=898ea38a&"
import script from "./16.vue?vue&type=script&lang=js&"
export * from "./16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VRadio,VRadioGroup,VTextField})
